module.exports = __webpack_public_path__ + "static/assets/f024c83fbbb2907f025f17547faaac8d.svg";